

export default class {
    /*SEGUIR EXATAMENTE ESTE PADRÃO CHAMANDO form: new XXX(), POIS SE MUDAR DARÁ ERRO COM OBJETO NÃO SENDO ALTERADO A CADA INCLUSÃO*/

    constructor() {

        return {
            productId: 0,
            productNumber: 0,
            groupProductId: 0,
            compoundId: 0,
            materialId: 0,
            productType: 1,//Produto
            modelId: 0,
            unitId: 0,
            reprovedEquivalentProductId:0,
            typeExclusive:90, //Não exclusivo
            customerId:0,
            customerGroupId:0,
            complementId:0,
            productCodeLabel: "",
            nameManually: "",
            nameAutomatically: "",
            forceNameManually: false,
            costLastValue: 0,
            costLastDate: "",
            costLastSupplier: "",
            saleValueDefault: 0,
            note: "",
            status: 1,
            featuresIds:[],
            keywords: [],
        }

    }
}